import dayjs from "dayjs";
import { StateCreator, create } from "zustand";
import { useTimeStore } from "./time-store";
import { devtools } from "zustand/middleware";

type PlayDirection = "forward" | "backward";

type TimeControlStore = {
  defaultTime: Dayjs;
  play: boolean;
  speed: number;
  direction: PlayDirection;
  setPlay: (p: boolean) => void;
  setSpeed: (s: number) => void;
  togglePlay: () => void;
  setDirection: (d: PlayDirection) => void;
  setDefaultTime: (t: Dayjs) => void;
};

export const useTimeControlStore = create<TimeControlStore>(set => ({
  defaultTime: dayjs(),
  play: true,
  speed: 5,
  direction: "forward",

  setPlay: (p: boolean) => {
    set({ play: p });
  },
  setSpeed: (s: number) => {
    set({ speed: s });
  },
  togglePlay: () => {
    set(state => {
      state.play = !state.play;
      return state;
    });
  },
  setDirection: (d: PlayDirection) => {
    set({ direction: d });
  },
  setDefaultTime: (t: Dayjs) => {
    set({ defaultTime: t });
    useTimeStore.setState({ time: t });
  }
}));
